/**
 * Runs as a classic (non-module) script right after Theme is defined so capture
 * runs before Horizon's delegated on:click handlers (e.g. cart drawer /open).
 *
 * - Menu or mobile drawer links to the cart → full page navigation
 * - Bare <cart-icon> in those surfaces (custom menu HTML) → same
 */
(function () {
  if (typeof Theme === 'undefined' || !Theme.routes?.cart_url) return;

  var cartUrl = Theme.routes.cart_url;

  function normalizePath(pathname) {
    return pathname.replace(/\/+$/, '') || '/';
  }

  function isHeaderMenuSurface(el) {
    if (!el || typeof el.closest !== 'function') return false;
    return !!(
      el.closest('header-menu') ||
      el.closest('.menu-drawer__navigation') ||
      el.closest('.menu-list--mobile') ||
      el.closest('.mega-menu')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('#header-component')) return;
      if (target.closest('cart-drawer-component')) return;

      var cartPath;
      try {
        cartPath = normalizePath(new URL(cartUrl, window.location.origin).pathname);
      } catch {
        return;
      }

      var cartIcon = target.closest('cart-icon');
      if (cartIcon && !cartIcon.closest('a[href]')) {
        if (!isHeaderMenuSurface(cartIcon)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(cartUrl);
        return;
      }

      var anchor = target.closest('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.target === '_blank' || anchor.hasAttribute('download')) return;

      var linkPath;
      try {
        linkPath = normalizePath(new URL(anchor.href, window.location.origin).pathname);
      } catch {
        return;
      }

      if (linkPath !== cartPath) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(anchor.href);
    },
    true
  );
})();
